import { CheckoutScreenTheme, EFeatureFlag, FeatureFlags, GetBootResponse } from '../contracts';
import { Theme } from '../providers/AppConfigProvider';
import { getBootLocalStorageKeyBySuffix } from './get-boot-local-storage-key';
import { getCheckoutToken } from './get-checkout-token';
import { getHostDomain } from './get-host-domain';
import { localStorageUtil } from './local-storage-util';

const getInitialBootFromLocalStorage = () => {
  const checkoutToken = getCheckoutToken();
  const bootLocalStorageKeyByCheckoutToken = getBootLocalStorageKeyBySuffix(checkoutToken);
  const bootByCheckoutToken = localStorageUtil.get(bootLocalStorageKeyByCheckoutToken);
  if (bootLocalStorageKeyByCheckoutToken && bootByCheckoutToken) {
    return bootByCheckoutToken;
  }
  const domain = getHostDomain();
  const bootLocalStorageKeyByDomain = getBootLocalStorageKeyBySuffix(domain);
  const bootByDomain = localStorageUtil.get(bootLocalStorageKeyByDomain);
  return bootByDomain;
};

const getBootFromURL = (): GetBootResponse | null => {
  const hash = window.location.hash.split('=');
  if (hash.length < 2) {
    return null;
  }

  try {
    const parsedData: GetBootResponse = JSON.parse(atob(hash[1]));
    return parsedData;
  } catch (error) {
    return null;
  }
};

const defaultTheme = {
  button: {
    color: '#7122FF',
    textColor: '#FFF',
  },
  text: '#000',
  primary: '#CACBD4',
  logo: '',
  backgroundImage: '',
  mobileBackgroundImage: '',
};

export const defaultFeatureFlags: FeatureFlags = {
  [EFeatureFlag.CHECKOUT_DISABLE_SUCCESS_SCREEN]: true,
};

export const appThemeAdaptar = (checkoutTheme: CheckoutScreenTheme): Theme => {
  if (!checkoutTheme) {
    return defaultTheme;
  }
  return {
    logo: checkoutTheme.logo,
    button: { color: checkoutTheme.buttonColor, textColor: checkoutTheme.buttonTextColor },
    primary: checkoutTheme.primaryColor,
    text: checkoutTheme.textColor,
    backgroundImage: checkoutTheme.backgroundImage,
    mobileBackgroundImage: checkoutTheme.mobileBgImage || checkoutTheme.backgroundImage,
  };
};

export const getInitialConfig = () => {
  const bootFromURL = getBootFromURL();
  const bootFromLocalStorage = getInitialBootFromLocalStorage() as GetBootResponse;
  const currentBoot = bootFromURL || bootFromLocalStorage;
  if (currentBoot) {
    const appTheme = appThemeAdaptar(currentBoot?.checkoutTheme);
    return {
      theme: appTheme,
      publisherId: currentBoot.checkoutTheme.publisherId,
      supportEmail: currentBoot.supportEmail,
      couponsConfiguration: currentBoot.couponsConfiguration,
      featureFlags: currentBoot.featureFlags,
      isDefaultBoot: false,
      publisherData: {
        companyId: currentBoot.publisherData.companyId,
        companyName: currentBoot.publisherData.companyName,
        storeTabName: currentBoot.publisherData.storeTabName,
        id: currentBoot.publisherData.id,
      },
    };
  }

  return { theme: defaultTheme, isDefaultBoot: true };
};
